import React, { useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import { injectIntl } from 'react-intl'

const SurveyAlertCaseCell = ({ task, intl, setHeightCallback }) => {
	let ref = React.createRef()
	useEffect(
		() => {
			if (setHeightCallback && ref.current) {
				setHeightCallback(ref.current.offsetHeight)
			}
		},
		[ ref ]
	)
	return (
		<div data-testid="mytasks-survey-alert-protocol-name" style={{ maxWidth: '300px' }} ref={ref}>
			<Typography
				data-testid="survey-alert-case-cell-info"
				variant="subtitle1"
				style={{
					wordBreak: 'break-all',
					color: '#011020'
				}}
			>
				{task && task.observationalProtocolName}
			</Typography>
			<Typography
				data-testid="survey-alert-case-cell-case-id"
				style={{
					textAlign: 'left',
					fontWeight: '400',
					fontSize: '13px',
					lineHeight: '16px',
					wordBreak: 'break-all',
					letterSpacing: '0.16px'
				}}
			>
				{`${intl.formatMessage({ id: 'app.general.caseId' })}: ${task.caseId36}`}
			</Typography>
		</div>
	)
}

const enhance = injectIntl

export default enhance(SurveyAlertCaseCell)
